// What the SOS inbox shows for one alert. A local ride's alert is looked up in the rides the panel
// already holds; an Intertown alert (sosEvents/{requestId}, kind 'intertown', written by
// firebase/functions/intertownSafety.js) carries what ops need on the document itself, because an
// Intertown trip is not in that list and the Rides console cannot open it.

/** Whether this alert is for an Intertown trip. */
export const isIntertownSos = (event) => event?.kind === 'intertown';

const text = (value) => String(value ?? '').trim();
const finite = (value) => (value === null || value === undefined || value === '' ? NaN : Number(value));

/** A Google Maps link for the position the alert carries, or null. */
export function sosMapUrl(event) {
  const lat = finite(event?.liveLocation?.lat);
  const lng = finite(event?.liveLocation?.lng);
  return Number.isFinite(lat) && Number.isFinite(lng) ? `https://maps.google.com/?q=${lat},${lng}` : null;
}

const SOURCE_LABEL = {
  pickup: 'Booked pickup (rider waiting there)',
  trip_relay: 'Anna\'s phone (trip tracking)',
  anna_phone: 'Anna\'s phone',
};

/** Where the position came from, in words ops can use ("Anna's phone, 2 min ago"). */
export function sosLocationNote(event, nowMs = Date.now()) {
  const live = event?.liveLocation;
  if (!sosMapUrl(event)) return '';
  const label = SOURCE_LABEL[live?.source] || 'Last known position';
  const at = finite(live?.at);
  const minutes = Number.isFinite(at) ? Math.round((nowMs - at) / 60000) : 0;
  return live?.source !== 'pickup' && minutes >= 1 ? `${label}, ${minutes} min ago` : label;
}

/**
 * The people and trip on one inbox row. For a local ride the passenger comes from the users and rides
 * the panel loaded; for an Intertown trip the alert's own copy fills the gaps.
 */
export function sosRowDetails(event, { user = null, ride = null } = {}) {
  const intertown = isIntertownSos(event);
  return {
    intertown,
    passengerName: text(user?.name || ride?.customerName || (intertown ? event?.customerName : '')),
    passengerPhone: text(user?.phone || ride?.customerPhone || (intertown ? event?.customerPhone : '')),
    annaName: intertown ? text(event?.driverName) : '',
    annaPhone: intertown ? text(event?.driverPhone) : '',
    vehicle: intertown ? text(event?.vehicleNumber) : '',
    route: intertown ? text(event?.routeText) : '',
    canInspectRide: !intertown,
  };
}
